module.exports = __webpack_public_path__ + "img/iwaly.fb0c425b.png";